import React from 'react';
import {toggleMobileMenu} from '../../actions/header';
import TranslatedComponent from '../../utils/TranslatedComponent';

function toggleMenu(dispatch) {
  dispatch(toggleMobileMenu());
}

class CloseIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <svg id='xCloseIcon' className='closeIcon' width="20px" height="20px" viewBox="0 0 20 20" version="1.1" onClick={toggleMenu.bind(this, this.props.dispatch)} aria-labelledby='close-title' role='img'>
        <title id='close-title'>Close</title>
        <g id="Components" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Headers" transform="translate(-983.000000, -834.000000)" fill="#FFFFFF">
            <path d="M993,842.548741 L985.008361,834.353365 C984.548921,833.882212 983.804021,833.882212 983.34458,834.353365 C982.88514,834.824518 982.88514,835.588408 983.34458,836.059562 L991.336219,844.254938 L983.841781,851.940438 C983.38234,852.411592 983.38234,853.175482 983.841781,853.646635 C984.301221,854.117788 985.046121,854.117788 985.505561,853.646635 L993,845.961135 L1000.49444,853.646635 C1000.95388,854.117788 1001.69878,854.117788 1002.15822,853.646635 C1002.61766,853.175482 1002.61766,852.411592 1002.15822,851.940438 L994.663781,844.254938 L1002.65542,836.059562 C1003.11486,835.588408 1003.11486,834.824518 1002.65542,834.353365 C1002.19598,833.882212 1001.45108,833.882212 1000.99164,834.353365 L993,842.548741 Z" id="Combined-Shape"></path>
          </g>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(CloseIcon);
module.exports = CloseIcon;



// WEBPACK FOOTER //
// ./client/src/components/header/CloseIcon.jsx